import { TournamentFollow, TournamentFollowWithDetails } from '../../domain/models';
import { TournamentFollowRepository } from '../../domain/repositories';
import { TournamentFollowDataSource } from '../datasources/TournamentFollowDataSource';
import {
  tournamentFollowEntityToModel,
  tournamentFollowWithDetailsEntityToModel,
} from '../entities';

export class TournamentFollowRepositoryImpl implements TournamentFollowRepository {
  constructor(private dataSource: TournamentFollowDataSource) {}

  async follow(userId: string, tournamentId: string): Promise<TournamentFollow> {
    const entity = await this.dataSource.create(userId, tournamentId);
    return tournamentFollowEntityToModel(entity);
  }

  async unfollow(userId: string, tournamentId: string): Promise<void> {
    await this.dataSource.delete(userId, tournamentId);
  }

  async getFollowedTournaments(
    userId: string,
    limit?: number,
    offset?: number
  ): Promise<TournamentFollowWithDetails[]> {
    const entities = await this.dataSource.getFollowedTournaments(userId, limit, offset);
    return entities.map(tournamentFollowWithDetailsEntityToModel);
  }

  async isFollowing(userId: string, tournamentId: string): Promise<boolean> {
    return await this.dataSource.isFollowing(userId, tournamentId);
  }

  async getFollowerCount(tournamentId: string): Promise<number> {
    return await this.dataSource.getFollowerCount(tournamentId);
  }
}
